import { Component, Injector } from '@angular/core';
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {ToastrService} from "ngx-toastr";
import {ProgressService} from "../../../services/progress.service";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {FacebookFundraiserService} from "../../../services/facebook-fundraiser.service";
import { BaseDialogComponent } from '../base-dialog/base-dialog.component';

@Component({
    selector: 'facebook-fundraiser-deletion-dialog',
    templateUrl: './facebook-fundraiser-deletion-dialog.component.html',
    styleUrls: ['./facebook-fundraiser-deletion-dialog.component.scss']
})
export class FacebookFundraiserDeletionDialogComponent extends BaseDialogComponent {

    private facebookFundraiserId: string;

    constructor(
        public activeModal: NgbActiveModal,
        private ToastrService: ToastrService,
        private progressService: ProgressService,
        private facebookFundraiserService: FacebookFundraiserService,
        public modalService: NgbModal,
        injector: Injector
    ) {
        super(injector);
    }

    deleteFacebookFundraiser() {
        this.progressService.startProgress(false);
        let obs = this.facebookFundraiserService.deleteFacebookFundraiserLink(this.facebookFundraiserId);
        if (obs) {
            obs.subscribe(() => {
                this.ToastrService.success('Facebook Fundraiser Link Deleted Successfully.');
                this.progressService.stopProgress(false);
                this.activeModal.close();
            }, err => {
                this.ToastrService.error('Error Deleting Facebook Fundraiser Link.');
                this.progressService.stopProgress(false);
                this.activeModal.close();
            });
        }
        this.progressService.stopProgress(false);
    }
}
